export default __webpack_public_path__ + "static/media/Soumyajit-Behera.394b6e42.pdf";